// extracted by mini-css-extract-plugin
export default {"desktopOrTabletScreen":"(min-width:768px)","root":"divider_root__klMZH","icon":"divider_icon__m-gzR"};